import type { AnalyticsEvent } from '../types/events.js';
import type { AnalyticsProvider } from '../types/providers.js';
import { STUDIO_PRODUCTION_HOST } from './constants.js';

export class GoogleTagManagerProvider implements AnalyticsProvider {
  name = 'google-tag-manager';
  private initialized = false;
  private scriptInjected = false;

  private readonly GTM_ID = 'GTM-TQNR8M2Z';

  private isProductionHost(): boolean {
    return window.location.host === STUDIO_PRODUCTION_HOST;
  }

  private injectScript(): void {
    if (this.scriptInjected) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      'event': 'gtm.js'
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.GTM_ID}`;
    document.head.insertBefore(script, document.head.firstChild);

    this.scriptInjected = true;
  }

  async initialize(): Promise<void> {
    if (!this.isProductionHost()) {
      this.initialized = false;
      return;
    }

    try {
      this.injectScript();
      this.initialized = true;
    } catch (error) {
      console.error('Failed to initialize Google Tag Manager:', error);
      this.initialized = false;
    }
  }

  async track(_event: AnalyticsEvent): Promise<void> {
    // TODO: implement --  No-op until specific conversion events are defined
  }

  async identify(userId: string, traits?: Record<string, any>): Promise<void> {
    if (!this.initialized || !window.dataLayer) return;

    window.dataLayer.push({
      userId,
      ...traits
    });
  }

  async reset(): Promise<void> {
    if (!this.initialized || !window.dataLayer) return;

    window.dataLayer.push({
      userId: undefined
    });
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}
